var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBugDroid = function SvgIconBugDroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.875a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M16.125 7.875a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.422 3.357a1 1 0 0 0-1.362-1.464l-1.291 1.202a8.5 8.5 0 0 0-9.557 0l-1.29-1.202a1 1 0 1 0-1.363 1.464l1.135 1.057a8.5 8.5 0 0 0-2.204 5.711v3.75a8.5 8.5 0 1 0 17 0v-3.75a8.5 8.5 0 0 0-2.204-5.71zm-7.432.268a6.5 6.5 0 0 0-6.5 6.5V11h13v-.875a6.5 6.5 0 0 0-6.5-6.5M5.49 13v.875a6.5 6.5 0 0 0 13 0V13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBugDroid;